// extracted by mini-css-extract-plugin
export default {"compareButton":"rTNhabD0os","compareButtonText":"N9yjNGtO04","compareDownloadIcon":"kKZYDu83yV"};